<!--
 * @Author: DaLong Li
 * @Date: 2025-02-19 19:15:10
 * @LastEditTime: 2025-02-19 19:18:04
 * @LastEditors: DaLong Li
 * @Description: 
 * 生命在于运动，代码在于抽动。
-->
<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
@import '@/styles/main.scss';
</style>
